import React, { useCallback, useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import * as stockActions from 'modules/stock';

import IssueStock from "./IssueStock";


const IssueRanking = () => {
  const [isFold, setFold] = useState(true);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();

  const issueStockList = useSelector(state => state.stock.issueStockList.data);
  
  const handleFold = useCallback(()=>{
    setFold(!isFold);
  },[isFold]);

  useEffect(()=>{
    dispatch(stockActions.getListIssueStock());
  },[dispatch])

  return (
    <>
      <aside>
        <div className="sectionHeader">
          <h2>이슈 종목</h2>
        </div>
        <ins className="kakao_ad_area" style={{display:'none'}}
          data-ad-unit    = "DAN-S5Csy1DGLOnDNqF7"
          data-ad-width   = "320"
          data-ad-height  = "100"
        ></ins>
        <div className="tab">
          <ul>
            <li><button type="button" className={page === 1 ? 'current' : ''} onClick={setPage.bind(null,1)}>1~10위</button></li>
            <li><button type="button" className={page === 2 ? 'current' : ''} onClick={setPage.bind(null,2)}>11~20위</button></li>
          </ul>
        </div>
        <div className={`stock${isFold ? ' fold' : ''}`}>
          <ul className={page === 2 ? 'second' : ''}>
            {issueStockList.map((issueStock, index) => (<IssueStock key={issueStock.stock_code} data={issueStock} rank={index+1}/>))}
          </ul>
          <button type="button" className={"view"+(isFold ? "" : " active")} onClick={handleFold}>전체보기</button>
        </div>
      </aside>
    </>
  )
}

export default IssueRanking;